<template>
  <div class="pub-tabs" :style="{ 'justify-content': jc, 'padding-left': pl }" :id="id + 'pub-tabs'">
    <div class="item" v-for="(item, index) in data" :key="index" :class="{ active: activeIndex === index }" :id="id +'tab' + index" @click="fn(index)">
      {{ $t(item) }}
      <img class="tabs-line-left" :style="{ width: widthL }" v-if="activeIndex === index || (Math.abs(activeIndex) == index)" src="https://static.worldaic.com.cn/2024/web/static/images/richeng_left.png" alt="">
      <img class="tabs-line-mid" :style="{ left: leftD }" v-if="activeIndex === index" src="https://static.worldaic.com.cn/2024/web/static/images/richeng_yuan.png" alt="">
      <img class="tabs-line-right" :style="{ width: widthR }" v-if="activeIndex === index || (Math.abs(activeIndex) == index)" src="https://static.worldaic.com.cn/2024/web/static/images/richeng_right.png" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: 'tabs',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    jc: {
      type: String,
      default: 'center'
    },
    padding: {
      type: String,
      default: '0'
    },
    pl: {
      type: String,
      default: '0'
    },
    width: {
      type: String,
      default: '1.96rem'
    },
    active: {
      type: Number,
      default: 0
    },
    id: {
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {
      activeIndex: 0,
      widthL: 0,
      widthR: 0,
      leftD: 0
    }
  },
  watch: {
    active: {
      handler(v) {
        this.activeIndex = v
        
        this.$nextTick(() => {
          const w1 = $(`#${this.id}pub-tabs`).width()
          if (this.activeIndex == -1) {
            this.widthL = `calc(${ w1 / 2 }px)`
            this.widthR = `calc(${ w1 / 2 }px)`
          }
        })
      },
      immediate: true
    },
    data: {
      handler(v) {
        if (v.length) {
          this.$nextTick(() => {
            this.getPosition()
          })
        }
      },
      immediate: true
    },
  },
  methods: {
    fn(index) {
      this.activeIndex = index
      this.$emit('update:active', index)
      this.$emit('click', index)
      this.$nextTick(() => {
        this.getPosition()
      })
    },
    getPosition() {
      const w1 = $(`#${this.id}pub-tabs`).width()
      const w2 = $(`#${this.id}tab${ this.activeIndex }`).width()
      const left = $(`#${this.id}tab${ this.activeIndex }`).position().left
      this.widthL = `calc(${ left + w2 / 2 }px - 0.16rem)`
      if (this.pl != 0) {
        this.widthR = `calc(${ w1 - left - w2 / 2 }px - 0.16rem + ${this.pl})`
      } else {
        this.widthR = `calc(${ w1 - left - w2 / 2 }px - 0.16rem)`
      }
      this.leftD = `calc(${ left + w2 / 2 }px - 0.06rem)`
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .pub-tabs {
    position: relative;
    width: 100%;
    text-align: center;

    .item {
      display: inline-block;
      font-size: .26rem;
      font-family: sybold;
      color: #9E9F9F;
      line-height: .4rem;
      cursor: pointer;
      margin-right: 1rem;

      &:last-child {
        margin-right: 0;
      }

      &.active {
        font-size: .32rem;
        color: #595757;
        background: linear-gradient(126deg, #2F9AF4 0%, RGBA(114, 85, 236, 1) 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    .tabs-line-left {
      position: absolute;
      height: .02rem;
      bottom: -0.13rem;
      left: 0;
    }

    .tabs-line-mid {
      position: absolute;
      height: .12rem;
      width: .12rem;
      bottom: -0.18rem;
    }

    .tabs-line-right {
      position: absolute;
      height: .02rem;
      bottom: -0.13rem;
      right: 0;
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  
}
</style>



// WEBPACK FOOTER //
// src/pages/forum/tabs.vue